import { render, staticRenderFns } from "./Zhuanyuan.vue?vue&type=template&id=b33ce7cc&"
import script from "./Zhuanyuan.vue?vue&type=script&lang=js&"
export * from "./Zhuanyuan.vue?vue&type=script&lang=js&"
import style0 from "./Zhuanyuan.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports